import React from 'react';
import { Body, useDirection } from '@edreamsodigeo/prisma-design-system';

interface Location {
  name: string;
  cityIata: string;
  cityName: string;
  iata: string;
  locationType: 'TRAIN_STATION' | 'AIRPORT';
  cityCode: string;
}

export interface SegmentLocationProps {
  type: 'DEPARTURE' | 'ARRIVAL';
  location: Location;
}

const SegmentLocation: React.FC<SegmentLocationProps> = ({
  type,
  location,
}) => {
  const isRtl = useDirection();
  const textAlign = type === 'DEPARTURE' ? 'left' : 'right';
  const textAlignRTL = type === 'DEPARTURE' ? 'right' : 'left';
  return (
    <Body
      type="small"
      color="neutral.70"
      textAlign={isRtl ? textAlignRTL : textAlign}
    >
      {location.locationType === 'TRAIN_STATION'
        ? location.cityIata
        : location.iata}
    </Body>
  );
};

export default SegmentLocation;
